import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { testServerConnection, testAccessGeneration } from './utils/serverTest';
import { testRealTimeUpdates, cleanupRealTimeTest } from './utils/realTimeTest';

// Make test functions available in window
if (process.env.NODE_ENV === 'development') {
  (window as any).testServerConnection = testServerConnection;
  (window as any).testAccessGeneration = testAccessGeneration;
  (window as any).testRealTimeUpdates = testRealTimeUpdates;
  (window as any).cleanupRealTimeTest = cleanupRealTimeTest;
  console.log('Test utilities available:');
  console.log('- testServerConnection() - Test server connection');
  console.log('- testAccessGeneration() - Test access pass generation');
  console.log('- testRealTimeUpdates() - Test real-time updates');
  console.log('- cleanupRealTimeTest() - Clean up real-time test listeners');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
